export default __webpack_public_path__ + "static/media/5.85a9bdc8.svg";